import { commonEnvVariables } from "@/commonEnvVariables";
export const headerConstant = {
    SEARCH_MAIL_TOOLTIP: 'Help us improve searching on Connect',
    MEMBER_DIRECTORY: 'Member Directory',
    SEE_ALL: 'See All',
    EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
    COOKIE_DESC1:
        'YPO and its partners use cookies and similar technologies to improve your Connect browsing experience and to collect information relating to your Connect activities for the purpose of providing you with tailored ads. You may disable these cookies in your browser; however, we may not be able to provide you with all or part of the Connect services. By clicking "Accept All Cookies," you consent to our',
    COOKIE_DESC2: 'which detail how we may collect and use visitor data.',
    PRIVACY_POLICY: 'Privacy Policy',
    ACCEPT_COOKIES: 'Accept all Cookies',
    AND: 'and',
    TERMS: 'Terms of Use',
    IMPERSONATE: 'impersonate',
    IMPERSONATION: 'Impersonation',
    menu: {
        HOME: 'Home',
        EVENTS: 'Events',
        MEMBERS: 'Members',
        RESOURCES: 'Resources',
        CONCIERGE: 'Concierge',
        REFER_MEMBER: 'Refer a Member',
        LEARNING_HUB: 'Learning Hub',
        MEMBER_BENEFITS: 'Member Benefits',
        NOTIFICATION_SETTINGS: 'Notification Settings',
        MORE: 'More',
        YPO_STORE: 'YPO Store',
    },
};


export const menuOptions = () => {
    const envVariables = commonEnvVariables();
    return [
        {
            label: 'Concierge',
            url: envVariables.CONCIERGE,
            newTab: true,
            key: 'concierge',
        },
        {
            label: 'Learning Hub',
            url: envVariables.LEARNING_HUB,
            newTab: true,
            key: 'learning_hub',
        },
        {
            label: 'Member Benefits',
            url: envVariables.MEMBER_BENEFITS,
            newTab: false,
            key: 'member_benefits',
        },
        {
            label: 'Refer a Member',
            url: envVariables.REFER_MEMBER,
            newTab: true,
            key: 'refer_a_member',
        },
        {
            label: 'YPO Store',
            url: envVariables.YPO_STORE,
            newTab: true,
            key: 'ypo_store',   
        }
    ];
};
export const notificationsConstants = {
    NOTIFICATIONS: 'Notifications',
    REPLIED_TO: 'replied to',
    LIKES: 'Likes',
    LIKES_POST: 'Likes Post',
    LIKES_COMMENT: 'Likes Comment',
    LIKES_REPLY: 'Likes Reply',
    REPLIES: 'Replies',
    COMMENTS: 'Comments',
    COMMENTED_ON: 'commented on',
    YOUR: 'your',
    IN: 'in',
    HOME: 'Home',
    SMALL_LIKES: 'liked',
    POST: 'post',
    COMMENT: 'comment',
    REPLY: 'reply',
    NEW_FOLLOWERS: 'New Followers',
    NEW_YPO_CONNECTIONS: 'New YPO Connections',
    NEW_CONVERSATION_POST: 'New Conversation Post',
    NEW_CONVERSATION_POST_MESSAGE: 'started a new conversation',
    STARTED_FOLLOWING_YOU: 'is now following you',
    ADDED_CONNECTION: 'added you to YPO Connections',
    MEMBER_MENTIONS: 'Member Mentions',
    MEMBER_MENSTIONED: 'just mentioned you',

};
